"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var ReactDOM = require("react-dom");
var classNames = require("classnames");
var gridRow_1 = require("spry-react/Grid/gridRow");
var GridCells = require("spry-react/Grid/gridCells");
var styles = require("spry-react/Grid/gridStyles");
var selectionStrategy_1 = require("spry-react/Selection/selectionStrategy");
var resize_observer_polyfill_1 = require("resize-observer-polyfill");
require("./grid.less");
var GridStyle;
(function (GridStyle) {
    GridStyle[GridStyle["Full"] = 0] = "Full";
    GridStyle[GridStyle["Simple"] = 1] = "Simple";
    GridStyle[GridStyle["SimpleNoHeaderDivider"] = 2] = "SimpleNoHeaderDivider";
})(GridStyle = exports.GridStyle || (exports.GridStyle = {}));
var Grid = /** @class */ (function (_super) {
    __extends(Grid, _super);
    function Grid(props) {
        var _this = _super.call(this, props) || this;
        _this.verticalScrollbarVisible = false;
        _this.adjustHeadersForScrollbar = function () {
            if (_this.props.hideHeaders)
                return;
            var gridElement = ReactDOM.findDOMNode(_this);
            var headerElement = gridElement.querySelector('.' + styles.gridHeader);
            var bodyElement = gridElement.querySelector('.' + styles.gridBody);
            if (!headerElement || !bodyElement) {
                return;
            }
            var bodyVerticalScrollbarWidth = headerElement.clientWidth - bodyElement.clientWidth;
            if (bodyVerticalScrollbarWidth > 1) {
                if (_this.state.hasVerticalScrollbar)
                    return;
                _this.setState({
                    //This will trigger an extra header "column" that matches up with the width of the vertical scrollbar in the body.
                    //This keeps the header columns aligned with the body columns.
                    hasVerticalScrollbar: true,
                    verticalScrollbarWidth: bodyVerticalScrollbarWidth,
                });
            }
            else {
                if (!_this.state.hasVerticalScrollbar)
                    return;
                _this.setState({
                    hasVerticalScrollbar: false,
                    verticalScrollbarWidth: 0
                });
            }
        };
        _this.getHeaders = function (headers) {
            var mappedHeaders = headers.map(function (header) {
                return typeof header === "string"
                    ? React.createElement(GridCells.TextHeader, { basis: '0px', growFactor: 1, label: header })
                    : header;
            });
            return mappedHeaders;
        };
        _this.augmentHeaders = function (headers) {
            var _a = _this.props, rows = _a.rows, allowMultiSelect = _a.allowMultiSelect, showSelectAllHeader = _a.showSelectAllHeader, rowExpansion = _a.rowExpansion;
            var selectionStrategy = _this.getSelectionStrategy();
            var augmentedHeaders = headers;
            //Add a checkbox header column if using one of the multi-select strategies
            if (allowMultiSelect) {
                var allRowKeys = rows.map(function (r) { return r.keyValue; });
                var allRowsAreSelected = selectionStrategy.areAllKeysSelected(allRowKeys);
                if (!!showSelectAllHeader || showSelectAllHeader === undefined) {
                    augmentedHeaders.unshift(React.createElement(GridCells.CheckboxHeader, { basis: '3rem', growFactor: 0, isChecked: allRowsAreSelected, toggleSelections: _this.toggleAllRowSelections, title: allRowsAreSelected ? "Deselect all" : "Select all" }));
                }
                else {
                    augmentedHeaders.unshift(React.createElement(GridCells.GridContentHeader, { basis: '3rem', growFactor: 0 }));
                }
            }
            //Add an icon header column if using row expansion
            if (rowExpansion && rowExpansion.includeToggleIcon) {
                augmentedHeaders.unshift(React.createElement(GridCells.IconHeader, { basis: 'auto' }));
            }
            return augmentedHeaders;
        };
        _this.multiselectCellCheckboxClass = "multiselectcell-checkbox";
        _this.getColumnFlexStyle = function (headers) {
            return headers.map(function (h) { return _this.getFlexStyle(h.props); });
        };
        _this.getRowColumnFlexStyle = function (rowDefinition, headerColumnWidthStyles) {
            return rowDefinition.columnWidths
                ? rowDefinition.columnWidths.map(function (c) { return _this.getFlexStyle(c); })
                : headerColumnWidthStyles;
        };
        _this.getFlexStyle = function (columnDefinition) {
            var basis = columnDefinition.basis, growFactor = columnDefinition.growFactor;
            if (basis === 'auto') {
                return {
                    flex: '0 0 auto',
                    minWidth: 0
                };
            }
            var absolutePattern = /^(\.?\d+\.?\d*(?:px|em|rem))/;
            if (absolutePattern.test(basis)) {
                var flexGrow = (growFactor !== null && growFactor !== undefined && growFactor.toString()) || '1';
                return {
                    flex: flexGrow + " 0 " + basis,
                    width: basis,
                    minWidth: 0
                };
            }
            console.warn("Unrecognized flex basis for a Grid cell: '" + basis + "'. Flex styles will not be applied to cells in this column.");
            return {};
        };
        _this.wrapMenuCell = function (rowCell, rowKey) {
            var isMenuCell = function (cellProps) { return cellProps && cellProps.isMenuCell; };
            if (isMenuCell(rowCell.props)) {
                return React.createElement(GridCells.MenuCell, { centerContent: rowCell.props.centerContent, contentCell: rowCell, key: rowCell.key || undefined, menuButtonClickHandler: function (e) { return _this.handleContextMenuButtonClick(rowKey, e); } });
            }
            return rowCell;
        };
        _this.handleBodyScroll = function (e) {
            var gridElement = ReactDOM.findDOMNode(_this);
            var headerElement = gridElement.querySelector('.' + styles.gridHeader);
            var bodyElement = gridElement.querySelector('.' + styles.gridBody);
            var totalsRows = gridElement.querySelectorAll('.' + styles.gridTotalsRow);
            if (!headerElement || !bodyElement) {
                return;
            }
            headerElement.scrollLeft = bodyElement.scrollLeft;
            totalsRows.forEach(function (r) { return r.scrollLeft = bodyElement.scrollLeft; });
        };
        _this.handleRowClick = function (rowKey, e) {
            var rowExpansion = _this.props.rowExpansion;
            var selectionStrategy = _this.getSelectionStrategy();
            if (!_this.isMultiselectCellCheckbox(e.nativeEvent.target)) //If the checkbox is clicked, the checkbox will call the selectionStrategy
                selectionStrategy.toggleKeySelection(rowKey, e);
            if (rowExpansion && rowExpansion.expandOnRowClick) {
                _this.toggleRowExpansion(rowKey);
            }
        };
        _this.isMultiselectCellCheckbox = function (clickTarget) {
            var _a, _b, _c;
            var classList = (_b = (_a = clickTarget) === null || _a === void 0 ? void 0 : _a.parentElement) === null || _b === void 0 ? void 0 : _b.classList;
            return (_c = classList) === null || _c === void 0 ? void 0 : _c.contains(_this.multiselectCellCheckboxClass);
        };
        _this.handleRightClick = function (rowKey, e) {
            e.stopPropagation();
            var selectionStrategy = _this.getSelectionStrategy();
            if (!selectionStrategy.isKeySelected(rowKey)) {
                selectionStrategy.selectOnly(rowKey);
            }
            if (_this.props.invokeContextMenuHandler) {
                e.preventDefault();
                _this.props.invokeContextMenuHandler(rowKey, { x: e.nativeEvent.clientX, y: e.nativeEvent.pageY });
            }
        };
        _this.handleDoubleClick = function (rowKey, e) {
            if (_this.props.onRowDoubleClick) {
                e.preventDefault();
                _this.props.onRowDoubleClick(rowKey);
            }
        };
        _this.handleContextMenuButtonClick = function (rowKey, e) {
            e.stopPropagation();
            var selectionStrategy = _this.getSelectionStrategy();
            if (!selectionStrategy.isKeySelected(rowKey)) {
                selectionStrategy.selectOnly(rowKey);
            }
            if (_this.props.invokeContextMenuHandler) {
                e.nativeEvent.stopImmediatePropagation();
                var button = e.target;
                _this.props.invokeContextMenuHandler(rowKey, { relativeElementId: button.id });
            }
        };
        _this.toggleAllRowSelections = function () {
            var allRowKeys = _this.props.rows.map(function (r) { return r.keyValue; });
            _this.getSelectionStrategy().toggleAllKeys(allRowKeys);
        };
        _this.toggleRowExpansion = function (rowKey, e) {
            if (e) {
                e.stopPropagation();
            }
            _this.setState(function (prevState) {
                return {
                    currentExpandedRowKey: rowKey === prevState.currentExpandedRowKey
                        ? null
                        : rowKey
                };
            });
        };
        _this.internalContextMenuSelectionTriggered = function (selectedKeys) {
            _this.setState({
                contextMenuInternalSelectionStrategy: new selectionStrategy_1.SingleSelectStrategy(selectedKeys, _this.internalContextMenuSelectionTriggered)
            });
        };
        _this.getSelectionStrategy = function () {
            return _this.props.selectionStrategy || _this.state.contextMenuInternalSelectionStrategy;
        };
        _this.state = {
            hasVerticalScrollbar: false,
            verticalScrollbarWidth: 0,
            currentExpandedRowKey: null,
            contextMenuInternalSelectionStrategy: !props.selectionStrategy && props.invokeContextMenuHandler ?
                new selectionStrategy_1.SingleSelectStrategy([], _this.internalContextMenuSelectionTriggered) : new selectionStrategy_1.NotSelectableStrategy()
        };
        _this.bodyRef = React.createRef();
        return _this;
    }
    Grid.prototype.render = function () {
        var _a, _b, _c;
        var _this = this;
        var headers = this.getHeaders(this.props.headers);
        var augmentedHeaders = this.augmentHeaders(headers);
        var columnWidthStyles = this.getColumnFlexStyle(augmentedHeaders);
        var totalsRows = this.props.totalsRows
            ? this.props.totalsRows.length !== undefined
                ? this.props.totalsRows
                : [this.props.totalsRows]
            : [];
        var _d = this.props, rows = _d.rows, rowExpansion = _d.rowExpansion;
        var _e = this.state, hasVerticalScrollbar = _e.hasVerticalScrollbar, verticalScrollbarWidth = _e.verticalScrollbarWidth, currentExpandedRowKey = _e.currentExpandedRowKey;
        var gridStyle = (this.props || GridStyle.Full).gridStyle;
        var isSimpleGrid = gridStyle === GridStyle.Simple || gridStyle === GridStyle.SimpleNoHeaderDivider;
        if (hasVerticalScrollbar) {
            augmentedHeaders.push((React.createElement("div", { key: 'grid-header-scrollbar', style: { flex: 'none', width: verticalScrollbarWidth + "px" } }, "\u00A0")));
        }
        var headerClasses = classNames(styles.gridHeader, (_a = {},
            _a[styles.gridHeaderSimple] = isSimpleGrid,
            _a[styles.gridHeaderNoDivider] = gridStyle === GridStyle.SimpleNoHeaderDivider,
            _a));
        var bodyClasses = classNames(styles.gridBody, (_b = {},
            _b[styles.gridBodySimple] = isSimpleGrid,
            _b));
        var selectionStrategy = this.getSelectionStrategy();
        var gridRows = rows.map(function (rowDefinition) {
            var rowKey = "grid-row-" + rowDefinition.keyValue;
            var rowCells = _this.withGridFeatureCells(rowDefinition);
            var rowColumnWidthStyles = _this.getRowColumnFlexStyle(rowDefinition, columnWidthStyles);
            rowCells = rowCells.map(function (cell, i) {
                return (React.createElement(GridCells.GridCellSizer, { style: __assign(__assign({}, rowColumnWidthStyles[i]), _this.getCellAlignmentStyles(cell.props.centerContent, cell.props.verticalAlignment)), key: cell.key || "cell-" + i }, _this.wrapMenuCell(cell, rowDefinition.keyValue)));
            });
            var isRowSelected = rowDefinition.isSelected || selectionStrategy.isKeySelected(rowDefinition.keyValue);
            if (rowExpansion) {
                var thisRowIsExpanded = rowDefinition.keyValue === currentExpandedRowKey;
                var expandedRowContent = thisRowIsExpanded
                    ? rowExpansion.getExpandedContent(rowDefinition.keyValue)
                    : null;
                return (React.createElement("div", { key: rowKey },
                    React.createElement(gridRow_1.ExpandableGridRow, { ref: rowDefinition.ref, cells: rowCells, allowSelection: selectionStrategy.allowsSelection, isSelected: isRowSelected, isExpanded: thisRowIsExpanded, expandedContent: expandedRowContent, clickHandler: function (e) { return _this.handleRowClick(rowDefinition.keyValue, e); }, rightClickHandler: function (e) { return _this.handleRightClick(rowDefinition.keyValue, e); }, doubleClickHandler: function (e) { return _this.handleDoubleClick(rowDefinition.keyValue, e); } })));
            }
            else {
                return (React.createElement("div", { key: rowKey },
                    React.createElement(gridRow_1.GridRow, { ref: rowDefinition.ref, autoHeight: rowDefinition.autoHeight, cells: rowCells, allowSelection: selectionStrategy.allowsSelection, isSelected: isRowSelected, clickHandler: function (e) { return _this.handleRowClick(rowDefinition.keyValue, e); }, rightClickHandler: function (e) { return _this.handleRightClick(rowDefinition.keyValue, e); }, doubleClickHandler: function (e) { return _this.handleDoubleClick(rowDefinition.keyValue, e); }, isSimpleGrid: isSimpleGrid })));
            }
        });
        var noDataRowClasses = classNames(styles.noDataGridRow, (_c = {},
            _c[styles.noDataGridRowSimple] = isSimpleGrid,
            _c));
        var noDataRow = rows.length === 0
            ? React.createElement("div", { className: noDataRowClasses }, this.props.noDataMessage)
            : null;
        return (React.createElement("div", { className: styles.gridTable, role: "table" },
            !this.props.hideHeaders &&
                React.createElement("div", { className: headerClasses, style: { flex: '0 0 auto' }, role: "row" }, augmentedHeaders.map(function (header, i) {
                    return React.createElement(GridCells.GridCellSizer, { style: columnWidthStyles[i], key: header.key || "header-" + i }, header);
                })),
            React.createElement("div", { className: bodyClasses, onScroll: this.handleBodyScroll, ref: this.bodyRef, role: "rowgroup" }, gridRows.length > 0 ? gridRows : noDataRow),
            totalsRows.map(function (totalsRow) {
                var totalsRowColumnWidthStyles = _this.getRowColumnFlexStyle(totalsRow, columnWidthStyles);
                return React.createElement("div", { key: totalsRow.keyValue, className: Grid.getTotalsClasses(totalsRow, isSimpleGrid) }, totalsRow.cells.map(function (totalsCell, i) {
                    return React.createElement(GridCells.GridCellSizer, { style: __assign(__assign({}, totalsRowColumnWidthStyles[i]), _this.getCellAlignmentStyles(totalsCell.props.centerContent, totalsCell.props.verticalAlignment)), key: totalsCell.key || "totals-cell-" + i }, totalsCell);
                }));
            })));
    };
    Grid.prototype.componentDidMount = function () {
        var _this = this;
        if (this.bodyRef.current) {
            var ro = new resize_observer_polyfill_1.default(function (entries, observer) {
                var bodyElement = entries[0].target;
                var visible = bodyElement.scrollHeight > bodyElement.clientHeight;
                if (visible !== _this.verticalScrollbarVisible) {
                    var scrollbarEvent = void 0;
                    //Because IE
                    if (typeof (Event) === 'function') {
                        scrollbarEvent = new Event('scrollbar');
                    }
                    else {
                        scrollbarEvent = document.createEvent('Event');
                        scrollbarEvent.initEvent('scrollbar', true, true);
                    }
                    bodyElement.dispatchEvent(scrollbarEvent);
                }
                _this.verticalScrollbarVisible = visible;
            });
            this.bodyRef.current.addEventListener('scrollbar', this.adjustHeadersForScrollbar);
            ro.observe(this.bodyRef.current);
        }
    };
    Grid.prototype.componentWillUnmount = function () {
        if (this.bodyRef.current) {
            this.bodyRef.current.removeEventListener('scrollbar', this.adjustHeadersForScrollbar);
        }
    };
    Grid.prototype.withGridFeatureCells = function (rowDefinition) {
        var _a = this.props, allowMultiSelect = _a.allowMultiSelect, rowExpansion = _a.rowExpansion;
        return __spreadArrays((rowExpansion && rowExpansion.includeToggleIcon ? [this.buildRowExpansionCell(rowDefinition)] : []), (allowMultiSelect ? [this.buildMultiselectCell(rowDefinition)] : []), rowDefinition.cells);
    };
    Grid.prototype.buildMultiselectCell = function (rowDefinition) {
        var selectionStrategy = this.props.selectionStrategy;
        var selectionDisabled = selectionStrategy ? !selectionStrategy.isKeySelectable(rowDefinition.keyValue) : false;
        var onToggle = selectionStrategy ? function () { return selectionStrategy.toggleKeySelection(rowDefinition.keyValue, { ctrlKey: true }); } : undefined;
        var tooltip = selectionDisabled
            ? undefined
            : !!rowDefinition.isSelected
                ? "Click to deselect row"
                : "Click to select row";
        return React.createElement(GridCells.CheckboxCell, { isSelected: !!rowDefinition.isSelected, disabled: selectionDisabled, key: 'grid-cell-checkbox', onToggle: onToggle, className: this.multiselectCellCheckboxClass, title: tooltip });
    };
    Grid.prototype.buildRowExpansionCell = function (rowDefinition) {
        var _this = this;
        var currentExpandedRowKey = this.state.currentExpandedRowKey;
        var thisRowIsExpanded = rowDefinition.keyValue === currentExpandedRowKey;
        var iconClass = thisRowIsExpanded ? 'open-up-icon' : 'open-down-icon';
        return React.createElement(GridCells.IconCell, { iconClass: iconClass, onClick: function (e) { return _this.toggleRowExpansion(rowDefinition.keyValue, e); }, key: 'grid-cell-row-expander-icon' });
    };
    Grid.prototype.getCellAlignmentStyles = function (centerContent, verticalAlignment) {
        var isCentered = !!centerContent;
        var centerstyles = isCentered ? { display: 'flex', justifyContent: 'center' } : {};
        var verticalAlignmentStyles = !!verticalAlignment ? GridCells.getVerticalCellAlignmentStyle(verticalAlignment) : {};
        return __assign(__assign({}, centerstyles), verticalAlignmentStyles);
    };
    Grid.defaultProps = {
        hideHeaders: false,
        allowMultiSelect: false,
    };
    Grid.getTotalsClasses = function (totalsRow, isSimpleGrid) {
        var _a;
        return classNames(styles.gridTotalsRow, (_a = {},
            _a[styles.gridTotalsRowSimple] = isSimpleGrid,
            _a[styles.gridRowAutoHeight] = totalsRow.autoHeight,
            _a));
    };
    return Grid;
}(React.Component));
exports.Grid = Grid;
